import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { AppleMessagesConnectPage } from "@/features/AppleMessages/AppleMessagesConnectPage";
import { isAppleMessagesConnectEnabled } from "@/features/AppleMessages/flag";

// The router's default search parser turns `?name=123` into a number and
// `?name=true` into a boolean; Apple sends these values as plain text.
const searchSchema = z.object({
  id: z.coerce.string().optional(),
  name: z.coerce.string().optional(),
  logo: z.coerce.string().optional(),
});

export const Route = createFileRoute("/_auth/apple-messages/connect")({
  validateSearch: zodValidator(searchSchema),
  beforeLoad: () => {
    if (!isAppleMessagesConnectEnabled()) {
      throw redirect({ to: "/" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { id, name, logo } = Route.useSearch();
  return <AppleMessagesConnectPage id={id} name={name} logo={logo} />;
}
